import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTrino = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-trino';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M8.24 7.135v4.136l-.33.24c-2.193 1.593-2.812 4.138-1.541 6.329.778 1.34 2.357 2.397 4.119 2.758 1.986.407 4.148-.05 5.651-1.195.971-.739 1.622-1.679 1.927-2.786.101-.365.11-.455.11-1.117s-.009-.752-.11-1.117c-.191-.694-.436-1.179-.887-1.763a5.6 5.6 0 0 0-.99-.978l-.188-.135.075-.123c.042-.068.934-1.618 1.984-3.444a1630 1630 0 0 1 1.982-3.441l.073-.121-.644-.371c-.354-.204-.657-.356-.675-.339-.017.018-.942 1.616-2.057 3.552a946 946 0 0 1-2.038 3.532 3.4 3.4 0 0 1-.44-.129c-1.317-.436-3.072-.472-4.311-.09l-.19.059V3H8.24zm4.587 4.687c1.954.29 3.526 1.561 3.82 3.088.057.295.057.885 0 1.18-.229 1.189-1.293 2.299-2.689 2.805-.72.26-1.119.325-1.998.325-.846-.001-1.132-.042-1.804-.261-1.454-.475-2.526-1.499-2.841-2.714a3.5 3.5 0 0 1 0-1.49c.38-1.466 1.883-2.642 3.747-2.932a7 7 0 0 1 1.765-.001M3.24 16v2h1.52v-4H3.24zm16 0v2h1.52v-4h-1.52z"
    })
  }));
});
export default SvgTrino;